var _defs, _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Profile_copy",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.09 62.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 25.14,
    cy: 26.03,
    r: 6.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.07,41.87c-2.46-4.63-7.32-7.79-12.93-7.79s-10.48,3.16-12.93,7.79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.86,52.4h8.41l8.17-4.57s-2.13-2.32-3.73-2.16c-1.85,.18-4.41,1.44-5.37,1.44s-6.46-3.37-11.02-3.49-8.48,3.61-8.48,3.61l-4.57,1.92,3.49,9.37,4.45-1.8s11.3,2.64,15.74,1.8,20.91-13.58,20.91-13.58c0,0-2.04-2.52-3.85-2.28s-7.37,4.36-7.37,4.36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.90f7ea06dfbdd43d6f7484b72d39912e.svg";
export { ForwardRef as ReactComponent };